import classNames from 'classnames';
import _ from 'lodash';
import React, { Component } from 'react';
import * as Utils from '../../../utilities/utils';
import './Slider.css';

// Props
// scrollTickInterval: number;
// horizontal?: boolean;

export default class Slider extends Component {
  // isTouch: boolean;
  // startEvent: 'touchstart' | 'mousedown';
  // moveEvent: 'touchmove' | 'mousemove';
  // endEvent: 'touchend' | 'mouseup';

  // resizeInterval: number;
  // autoInterval: number;
  // sliderContentRef: HTMLElement | null;
  // sliderRef: HTMLElement | null;

  constructor(props) {
    super(props);

    this.state = {
      sliderPosition: 0,
      sliderOldPosition: 0,
      sliderDownPosition: 0,
      sliderContentSize: 0,
      sliderSize: 0,
      sliding: false,
      snapDuration: 300,
      snapPosition: 0,
      snapAmount: 0
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this.isTouch = 'ontouchstart' in window;
    this.startEvent = this.isTouch ? 'touchstart' : 'mousedown';
    this.moveEvent = this.isTouch ? 'touchmove' : 'mousemove';
    this.endEvent = this.isTouch ? 'touchend' : 'mouseup';
  }

  componentWillMount() {
    this.onMovePressed = this.onMovePressed.bind(this);
    this.onMovePressed = _.throttle(this.onMovePressed, 40);
    this.onWindowMouseUp = this.onWindowMouseUp.bind(this);

    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchMove = _.throttle(this.onTouchMove, 40);
    this.onWindowTouchEnd = this.onWindowTouchEnd.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();
    this.resizeInterval = window.setInterval(this.updateDimensions, 250);
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.clearInterval(this.resizeInterval);
    window.removeEventListener(this.moveEvent, this.onMovePressed);
    window.removeEventListener(this.endEvent, this.onWindowMouseUp);
    window.removeEventListener(this.moveEvent, this.onTouchMove);
    window.removeEventListener(this.endEvent, this.onWindowTouchEnd);
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    if (this.sliderContentRef && this.sliderRef) {
      const sliderContentRect = this.sliderContentRef.getBoundingClientRect();
      const sliderRect = this.sliderRef.getBoundingClientRect();
      const newContentSize = this.props.horizontal ? sliderContentRect.width : sliderContentRect.height;
      const newSize = this.props.horizontal ? sliderRect.width : sliderRect.height;

      if (newContentSize !== this.state.sliderContentSize || newSize !== this.state.sliderSize) {
        if (this.state.sliderPosition < Math.min(newSize - newContentSize, 0)) {
          const newPosition = Math.min(newSize - newContentSize, 0);
          this.scroll(newPosition);
        }
        this.setState({
          sliderContentSize: newContentSize,
          sliderSize: newSize
        });
      }
    }
  }

  autoScroll() {
    let snapPosition = null;
    if (this.state.sliderPosition > 0) {
      snapPosition = 0;
    }
    else if (this.state.sliderPosition < Math.min(this.state.sliderSize - this.state.sliderContentSize, 0)) {
      snapPosition = Math.min(this.state.sliderSize - this.state.sliderContentSize, 0);
    }
    if (snapPosition != null) {
      this.scroll(snapPosition);
    }
  }

  scroll(toPosition) {
    this.setState({
      sliderOldPosition: this.state.sliderPosition,
      snapPosition: toPosition,
      snapAmount: 0
    }, () => {
      this.cancelScroll();
      this.autoInterval = window.setInterval(() => {
        const newSnapAmount = Math.min(this.state.snapAmount + this.props.scrollTickInterval / this.state.snapDuration, 1);
        const delta = (this.state.snapPosition - this.state.sliderOldPosition) * Utils.easeInOutCubic(newSnapAmount);
        if (newSnapAmount === 1) {
          this.cancelScroll();
        }
        this.setState({
          snapAmount: newSnapAmount,
          sliderPosition: this.state.sliderOldPosition + delta
        });
      }, this.props.scrollTickInterval);
    });
  }

  cancelScroll() {
    window.clearInterval(this.autoInterval);
  }

  scrollToChild(index, numChildren) {
    if (index < numChildren) {
      let childPosition = -1 * Math.floor(index * this.state.sliderContentSize / numChildren);
      if (childPosition < Math.min(this.state.sliderSize - this.state.sliderContentSize, 0)) {
        childPosition = Math.min(this.state.sliderSize - this.state.sliderContentSize, 0);
      }
      this.scroll(childPosition);
    }
  }

  onWindowMouseUp = e => {
    window.removeEventListener(this.moveEvent, this.onMovePressed);
    window.removeEventListener(this.endEvent, this.onWindowMouseUp);
    (this.onMovePressed).flush();
    this.autoScroll();
  }

  onWindowTouchEnd = e => {
    window.removeEventListener(this.moveEvent, this.onTouchMove);
    window.removeEventListener(this.endEvent, this.onWindowTouchEnd);
    (this.onTouchMove).flush();
    this.autoScroll();
  }

  onMovePressed = e => {
    this.cancelScroll();
    let delta = this.props.horizontal
      ? e.pageX - this.state.sliderDownPosition
      : e.pageY - this.state.sliderDownPosition;

    if (Math.abs(delta) > 10 && this.state.sliding === false) {
      this.setState({
        sliding: true,
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
    else if (this.state.sliding) {
      this.setState({
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
  }

  onTouchMove = e => {
    const touch = e.touches[0];
    this.cancelScroll();
    let delta = this.props.horizontal
      ? touch.pageX - this.state.sliderDownPosition
      : touch.pageY - this.state.sliderDownPosition;

    if (Math.abs(delta) > 10 && this.state.sliding === false) {
      this.setState({
        sliding: true,
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
    else if (this.state.sliding) {
      this.setState({
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
  }

  onMouseDown = e => {
    window.setTimeout(this.updateDimensions, 40);
    this.setState({
      sliderOldPosition: this.state.sliderPosition,
      sliderDownPosition: this.props.horizontal ? e.pageX : e.pageY,
      sliding: false
    }, () => {
      // remove the listeners first in case strays are lying around
      window.removeEventListener(this.moveEvent, this.onMovePressed);
      window.removeEventListener(this.endEvent, this.onWindowMouseUp);

      window.addEventListener(this.moveEvent, this.onMovePressed);
      window.addEventListener(this.endEvent, this.onWindowMouseUp);
    });
  }

  onTouchStart = e => {
    window.setTimeout(this.updateDimensions, 40);
    const touch = e.touches[0];
    this.setState({
      sliderOldPosition: this.state.sliderPosition,
      sliderDownPosition: this.props.horizontal ? touch.pageX : touch.pageY,
      sliding: false
    }, () => {
      // remove the listeners first in case strays are lying around
      window.removeEventListener(this.moveEvent, this.onTouchMove);
      window.removeEventListener(this.endEvent, this.onWindowTouchEnd);

      window.addEventListener(this.moveEvent, this.onTouchMove);
      window.addEventListener(this.endEvent, this.onWindowTouchEnd);
    });
  }

  onMouseUp = () => {
    window.setTimeout(this.updateDimensions, 100);
  }

  onClickCapture = e => {
    if (this.state.sliding) {
      e.stopPropagation();
    }
  }

  onClickNext = () => {
    const numChildren = React.Children.count(this.props.children);
    const avgItemSize = Math.floor(this.state.sliderContentSize / numChildren);
    const extent = Math.min(this.state.sliderSize - this.state.sliderContentSize, 0);
    const toPosition = Math.max(this.state.sliderPosition - avgItemSize, extent);
    this.scroll(toPosition);
  }

  onClickPrev = () => {
    const numChildren = React.Children.count(this.props.children);
    const avgItemSize = Math.floor(this.state.sliderContentSize / numChildren);
    const toPosition = Math.min(this.state.sliderPosition + avgItemSize, 0);
    this.scroll(toPosition);
  }

  render() {
    const sliderContentStyle = this.props.horizontal 
      ? {
        left: this.state.sliderPosition
      }
      : {
        top: this.state.sliderPosition
      };

    const sliderClasses = classNames('Slider', {
      'Slider-horizontal': this.props.horizontal
    });
    return (
      <div
        className={sliderClasses}
        ref={(x) => { this.sliderRef = x; }}
        onMouseDown={this.isTouch ? undefined : this.onMouseDown}
        onTouchStart={this.isTouch ? this.onTouchStart : undefined}
        onClickCapture={this.onClickCapture}
        onMouseUp={this.onMouseUp}
      >
        <div className={'Slider-content'} ref={(x) => { this.sliderContentRef = x; }} style={sliderContentStyle}>
          {this.props.children}
        </div>
        {this.state.sliderPosition > Math.min(this.state.sliderSize - this.state.sliderContentSize, 0) && !this.props.isCheckout && (
          <div className={'Slider-next'} onClick={this.onClickNext}>
            {this.props.horizontal
              ? <img alt={'Arrow Right'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowRight.png`} />
              : <img alt={'Arrow Down'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowDown.png`} />
            }
          </div>
        )}
        {this.state.sliderPosition < 0 && !this.props.isCheckout &&  (
          <div className={'Slider-prev'} onClick={this.onClickPrev}>
            {this.props.horizontal
              ? <img alt={'Arrow Left'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowLeft.png`} />
              : <img alt={'Arrow Up'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowUp.png`} />
            }
          </div>
        )}
      </div>
    );
  }
}
